<template>
  <div>
    <base-header class="pb-8 pt-3">
      <!-- Card stats -->
      <b-row>
        <b-col md="3"></b-col>
      </b-row>
    </base-header>

    <b-container fluid class="mt--6">
      <b-row>
        <b-col>
          <div
            class="card card-flush shadow-sm mb-xl-8 animate__animated animate__fadeIn"
          >
            <div class="card-header border-0">
              <div class="row">
                <div class="col-md-6">
                  <h3
                    class="card-title align-items-start flex-column w-lg-50 mb-0"
                  >
                    <div class="w-lg-50 col-6 px-0">
                      <div class="d-flex justify-content-end">
                        <input
                          type="text"
                          v-model="pagination.find"
                          class="form-control form-control-sm form-control-solid"
                          placeholder="Buscar por email"
                          name="card_cvv"
                          :class="{ 'bg-light-warning': pagination.find != '' }"
                        />
                        <div class="position-absolute mt-1 mr-2">
                          <i
                            v-if="pagination.find == ''"
                            class="fa fa-search text-secondary"
                          ></i>
                          <i
                            v-if="pagination.find != ''"
                            @click="pagination.find = ''"
                            class="fa fa-times-circle text-danger c-pointer"
                          ></i>
                        </div>
                      </div>
                    </div>
                    <!-- <span class="text-muted mt-1 fw-bold fs-7">Over 500 members</span> -->
                  </h3>
                </div>
                <div class="col-md-6 text-right">
                  <button @click="showModal()" class="btn btn-primary btn-sm">
                    <i class="fa fa-pencil"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="card-body py-0">
              <div class="table-responsive">
                <table
                  class="getting table align-items-center table-flush table-sm table-hover"
                >
                  <thead class="thead-light">
                    <tr
                      class="fw-bold fs-7 text-gray-500 border-bottom border-gray-200 py-4"
                    >
                      <!-- <th class="w-25px">
                  <div class="form-check form-check-sm form-check-custom form-check-solid">
                    <input class="form-check-input" type="checkbox" value="1" data-kt-check="true" data-kt-check-target=".widget-9-check">
                  </div>
                </th> -->
                      <th class="min-w-100px">Id</th>
                      <th class="min-w-100px">Empleado</th>
                      <th class="min-w-100px">Email</th>
                      <th class="min-w-100px">Administrador</th>
                      <th class="min-w-100px">Supervisor</th>
                      <th class="text-center">Cajero</th>
                      <th class="text-center">Estatus</th>
                      <th class="min-w-100px text-end">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, kr) in elements" :key="kr" class="">
                      <td>{{ row.id }}</td>
                      <td>{{ row.empleado.nombre }}</td>
                      <td>{{ row.email }}</td>
                      <td class="text-center">
                        <i
                          v-if="row.administrador"
                          class="fas fa-check-circle text-success"
                        ></i>
                      </td>
                      <td class="text-center">
                        <i
                          v-if="row.supervisor"
                          class="fas fa-check-circle text-success"
                        ></i>
                      </td>
                      <td class="text-center">
                        <i
                          v-if="row.cajero"
                          class="fas fa-check-circle text-success"
                        ></i>
                      </td>
                      <td class="text-center">
                        <ItemState :cancel="row.cancel" />
                      </td>
                      <td>
                        <div class="d-flex justify-content-end flex-shrink-0">
                          <button
                            @click="showModal(row)"
                            class="btn btn-primary btn-sm"
                          >
                            <i class="fa fa-pencil"></i>
                          </button>
                          <ButtonDelete
                            :cancel="row.cancel"
                            @onDelete="cancel(row)"
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="card-footer pt-2 d-flex justify-content-between">
              <div class="row">
                <label for="" class="col">Registros por página:</label>
                <select
                  v-model="pagination.limit"
                  class="col form-control form-control-sm"
                  @change="changeLimit"
                >
                  <option value="15">15</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>
              <ul class="pagination">
                <!-- Botón para ir a la primera página -->
                <li class="page-item">
                  <button
                    @click="goToPage(1)"
                    :disabled="pagination.page === 1"
                    class="page-link"
                  >
                    <i class="fas fa-angle-double-left"></i>
                  </button>
                </li>

                <!-- Botón de página anterior -->
                <li class="page-item">
                  <button
                    @click="goToPage(pagination.page - 1)"
                    :disabled="!pagination.previousPage"
                    class="page-link"
                  >
                    <i class="fas fa-angle-left"></i>
                  </button>
                </li>

                <!-- Páginas dinámicas -->
                <li
                  v-for="page in visiblePages"
                  :key="page"
                  class="page-item"
                  :class="{ active: pagination.page === page }"
                >
                  <button @click="goToPage(page)" class="page-link">
                    {{ page }}
                  </button>
                </li>

                <!-- Botón de página siguiente -->
                <li class="page-item">
                  <button
                    @click="goToPage(pagination.page + 1)"
                    :disabled="!pagination.nextPage"
                    class="page-link"
                  >
                    <i class="fas fa-angle-right"></i>
                  </button>
                </li>

                <!-- Botón para ir a la última página -->
                <li class="page-item">
                  <button
                    @click="goToPage(totalPages)"
                    :disabled="pagination.page === totalPages"
                    class="page-link"
                  >
                    <i class="fas fa-angle-double-right"></i>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-modal
      id="modal-user"
      title="Configuración de Usuario"
      hide-footer
      header-class="border d-flex align-items-center"
      title-class="h4"
    >
      <b-form-group>
        <!-- <b-form-group label="Colaborador">
          <b-form-input
            v-if="form.empleado_id"
            :value="form.empleado.nombre"
            disabled
          ></b-form-input>
          <b-form-select v-if="!form.empleado_id" v-model="form.empleado_id">
            <b-form-select-option value="" disabled selected
              >Seleccione empleado</b-form-select-option
            >
            <b-form-select-option
              v-for="(empleado, ke) in empleados"
              :key="ke"
              :value="empleado.id"
              class="text-dark"
              >{{ empleado.nombre }}</b-form-select-option
            >
          </b-form-select>
        </b-form-group> -->
        <b-form-group label="Nombre">
          <b-form-input
            type="text"
            v-model="form.nombre"
            class="form-control-solid"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Email">
          <b-form-input
            type="text"
            v-model="form.email"
            class="form-control-solid"
          ></b-form-input>
        </b-form-group>
        <b-form-checkbox
          id="checkbox-administrador"
          v-model="form.administrador"
          name="checkbox-1"
          value="1"
          unchecked-value="0"
        >
          Administrador sistema
        </b-form-checkbox>
        <b-form-checkbox
          id="checkbox-supervisor"
          v-model="form.supervisor"
          name="checkbox-1"
          value="1"
          unchecked-value="0"
        >
          Supervisor
        </b-form-checkbox>
        <b-form-checkbox
          id="checkbox-cajero"
          v-model="form.cajero"
          name="checkbox-1"
          value="1"
          unchecked-value="0"
        >
          Cajero
        </b-form-checkbox>
      </b-form-group>
      <ResetPassword label="Restablecer contraseña" :userId="form.id" />
      <b-button
        @click="save"
        :disabled="working"
        variant="primary"
        class="float-right"
        size="sm"
        >Guardar</b-button
      >
    </b-modal>
  </div>
</template>
<script>
import ItemState from "@/components/IDBRICS/tools/ItemState";
import ButtonDelete from "@/components/IDBRICS/tools/ButtonDelete";
import ResetPassword from "@/components/IDBRICS/Users/ResetPassword";

export default {
  components: {
    ItemState,
    ButtonDelete,
    ResetPassword,
  },
  data: function () {
    return {
      working: false,
      pagination: {
        page: 1,
        limit: 15,
        total: 0,
        columns: [
          "id",
          "email",
          "administrador",
          "supervisor",
          "cajero",
          "cancel",
        ],
        where: null,
        find: "",
        order_by: "",
        order_direction: "",
        data_search: "",
        nextPage: null,
        previousPage: null,
      },
      sucursales: [],
      empleados: [],
      elements: [],
      form: {},
    };
  },
  watch: {
    "pagination.find": function (val) {
      this.getUsuarios();
    },
  },
  beforeMount() {
    this.resetForm();

    // this.getSucursales();

    this.getEmpleados();

    this.getUsuarios();
  },
  computed: {
    totalPages() {
      return Math.ceil(this.pagination.total / this.pagination.limit);
    },
    visiblePages() {
      let pages = [];
      let totalPages = this.totalPages;
      let currentPage = this.pagination.page;

      let startPage = Math.max(1, currentPage - 2);
      let endPage = Math.min(totalPages, currentPage + 2);

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      return pages;
    },
  },
  methods: {
    resetForm() {
      this.form = {
        empleado_id: "",
        administrador: 0,
        supervisor: 0,
        cajero: 0,
      };
    },
    getEmpleados() {
      this.empleados = [];

      this.$api
        .get("empleados/no-user")
        .then((response) => {
          this.empleados = response.data;
        })
        .catch((e) => console.error(e));
    },
    getUsuarios() {
      this.getting = true;

      this.$api
        .get(`users`, {
          params: this.pagination,
        })
        .then((response) => {
          this.pagination.total = response.data.total;
          this.pagination.nextPage = response.data.nextPage;
          this.pagination.previousPage = response.data.previousPage;
          this.elements = response.data.rows;
        })
        .catch((e) => {
          this.$notiflix.Report.failure(
            "Error Interno",
            "No fue posible obtener el recurso solicitado, serás dirigido al inicio y puedes intentarlo nuevamente.",
            "Entendido",
            () => {
              this.$router.push("/");
            }
          );
        })
        .then(() => (this.getting = false));
    },
    getSucursales() {
      this.$api
        .get(
          "sucursales?page=1&limit=15&total=0&find=&order_by=&order_direction=&data_search="
        )
        .then((response) => {
          this.sucursales = response.data.rows;
        })
        .catch((e) => console.error(e));
    },
    setForm(item) {
      this.form = Object.assign(this.form, item);
    },
    showModal(item = null) {
      if (item) {
        this.setForm(item);
      } else {
        console.log("reset");
        this.resetForm();
      }

      this.$bvModal.show("modal-user");
    },
    hideModal() {
      this.$bvModal.hide("modal-user");
      this.date = "";
    },
    async save(event) {
      try {
        event.preventDefault();

        this.working = true;

        let response = null;

        if (this.form.id) {
          response = await this.$api.put(`users/${this.form.id}`, this.form);
        } else {
          response = await this.$api.post(`users`, this.form);
        }

        console.log(response.data);

        this.$notiflix.Report.success(
          "Usuario creado",
          "El usuario ha sido creado correctamente.",
          "Entendido",
          () => {
            this.getUsuarios();
          }
        );

        this.hideModal();

        this.resetForm();
      } catch (error) {
        alert("No fue posible guardar el registro.");
      } finally {
        this.working = false;
      }
    },
    async save_(event) {
      try {
        event.preventDefault();

        this.working = true;

        let response = null;

        if (this.form.id) {
          response = await this.$api.put(
            `empleados/${this.form.empleado_id}/user`,
            this.form
          );
        } else {
          response = await this.$api.post(
            `empleados/${this.form.empleado_id}/user`,
            this.form
          );
        }

        // const response = await this.$api.post(
        //   `empleados/${this.form.empleado_id}/user`,
        //   this.form
        // );

        // Add if not exist
        this.getUsuarios();
        // this.getEmpleados();

        // this.$forceUpdate();

        this.hideModal();

        this.resetForm();
      } catch (error) {
        this.$notiflix.Report.failure(
          "Error Interno",
          error.response.data.errors[0] ||
            error.response.data.message ||
            "No fue posible guardar el registro.",
          "Entendido"
          // () => {
          //   this.$router.push("/");
          // }
        );
      } finally {
        this.working = false;
      }
    },
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.pagination.page = page;
        this.getUsuarios();
      }
    },
    changeLimit() {
      this.pagination.page = 1; // Reiniciar a la primera página cuando cambia el límite
      this.getUsuarios();
    },
  },
};
</script>
